import React, { Component } from "react";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import AdminProjectPitches from "../components/AdminProjectPitches";
import * as adminActions from "./../../../../../actions/admin.actions";
import * as commonActions from "../../../../../actions/common.actions";
import * as projectActions from "../../../../../actions/project.actions";

const approvedSubHeader = (projectId, totalMatches, totalPitches) => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: `Matches (${totalMatches})`,
        url: `/admin/project/${projectId}/matches`
      },
      {
        caption: `Pitches (${totalPitches})`,
        url: `/admin/project/${projectId}/pitches`
      },
      {
        caption: "SOW",
        url: `/admin/project/${projectId}/sow`
      },
      {
        caption: "Reviews",
        url: `/admin/project/${projectId}/reviews`
      }
    ],
    activeItem: 2
  };
};

class AdminProjectPitchesContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentProjectState: null
    };
  }

  componentDidMount() {
    this.props.adminActions.getProject(this.props.match.params.projectId);
    this.props.projectActions.getStatus();
  }

  componentDidUpdate(prevProps, prevState) {
    this.setHeaderBar(prevState);
  }

  setHeaderBar(prevState) {
    const project = this.props.project;
    const status = _.get(project, "status.name");

    const totalMatches = _.get(project, "stats.matches.matched");
    const totalPitches =
      _.get(project, "stats.pitches.accepted") +
      _.get(project, "stats.pitches.pending");

    let headerBar = {};
    let subHeader = {};
    let currentProjectState = status;

    if (status != undefined) {
      subHeader = approvedSubHeader(project.id, totalMatches, totalPitches);
    }

    if (currentProjectState !== prevState.currentProjectState) {
      this.props.commonActions.setHeaderBar(headerBar);
      this.props.commonActions.setSubHeader(subHeader);
      this.setState({ currentProjectState });
    }
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  render() {
    const { project } = this.props;

    return _.isEmpty(project) ? null : (
      <AdminProjectPitches project={project} />
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.admin.project
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminProjectPitchesContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/project/pitches/containers/AdminProjectPitchesContainer.js